module.exports = __webpack_public_path__ + "img/body_w.027bbd3f.png";